import type { SceneTimelineKeyPoseFromAPI } from '../types';
import apiRequest from './apiRequest';
import type { MotionEditorJobResponse } from './postSceneObjectMotionEdit';

export type MotionKeyPoseStatePayload = SceneTimelineKeyPoseFromAPI[];

export type CreateKeyPoseEditRequest = {
  keyPoses: MotionKeyPoseStatePayload;
  prompt?: string;
  duration?: number;
  sampler?: string;
  seed?: number | null;
  callbackURLs?: string[];
};

export default async function postSceneObjectMotionKeyPoseEdit(
  sceneID: string,
  referenceName: string,
  timelineIndex: number,
  request: CreateKeyPoseEditRequest,
  apiKey: string,
  signal?: AbortSignal,
) {
  return apiRequest<MotionEditorJobResponse>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}/objects/${encodeURIComponent(referenceName)}/${timelineIndex}/keyPoseEdits`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(request),
    },
    signal,
  );
}
